import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag, Calculator, Dumbbell, Ban, XCircle } from 'lucide-react';
interface Attempt {
  icon: React.ReactNode;
  highlight: string;
  text: string;
}
const attempts: Attempt[] = [{
  icon: <ShoppingBag className="w-6 h-6" strokeWidth={1.75} data-id="element-75" />,
  highlight: 'Las dietas de internet',
  text: 'usan ingredientes caros y exóticos que no pillas ni en el Jumbo más grande — y te hacen sentir que "no puedes" antes de empezar.'
}, {
  icon: <Calculator className="w-6 h-6" strokeWidth={1.75} data-id="element-76" />,
  highlight: 'Contar calorías',
  text: 'no sirve si lo que comes está irritando tus hormonas y tu intestino todos los días. Puedes comer "poco" y seguir inflamada.'
}, {
  icon: <Dumbbell className="w-6 h-6" strokeWidth={1.75} data-id="element-77" />,
  highlight: 'El enfoque "Fit" tradicional',
  text: 'requiere horas de cocina, suplementos caros y una disciplina que una mujer profesional y jefa de hogar simplemente no tiene tiempo de sostener.'
}, {
  icon: <Ban className="w-6 h-6" strokeWidth={1.75} data-id="element-78" />,
  highlight: 'Los productos "light" y "diet" del supermercado',
  text: 'están llenos de aditivos, edulcorantes y aceites vegetales que aumentan la inflamación en lugar de reducirla. El carrito "saludable" que crees que armas… puede estar trabajando en tu contra.'
}];
export function FailedAttempts() {
  return <section className="py-12 md:py-14 bg-brand-cream" data-id="element-79">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl" data-id="element-80">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-81">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy leading-tight" data-id="element-82">
            El problema no eres tú.{' '}
            <span className="text-brand-gold" data-id="element-83">
              Es el sistema que te vendieron.
            </span>
          </h2>
        </motion.div>

        {/* Failed attempts list */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-84">
          {attempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="relative bg-white p-6 sm:p-7 rounded-2xl shadow-sm border border-brand-navy/5 flex gap-4 group hover:shadow-md transition-shadow" data-id="element-85">
              {/* Red X badge on top corner */}
              <div className="absolute -top-3 -left-3 w-9 h-9 bg-red-500/90 rounded-full flex items-center justify-center shadow-md ring-4 ring-brand-cream" data-id="element-86">
                <XCircle className="w-5 h-5 text-white" strokeWidth={2.5} data-id="element-87" />
              </div>

              {/* Icon */}
              <div className="shrink-0 mt-1" data-id="element-88">
                <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center text-red-500/80" data-id="element-89">
                  {attempt.icon}
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0" data-id="element-90">
                <p className="text-gray-700 leading-relaxed text-base" data-id="element-91">
                  <span className="font-bold text-brand-navy" data-id="element-92">
                    {attempt.highlight}
                  </span>{' '}
                  {attempt.text}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-12 text-center max-w-3xl mx-auto" data-id="element-93">
          <p className="text-lg sm:text-xl font-serif font-medium text-brand-navy leading-relaxed" data-id="element-94">
            Ninguno de estos enfoques fue diseñado para{' '}
            <span className="text-brand-gold italic" data-id="element-95">
              tu metabolismo actual
            </span>
            . Para tu cuerpo después de los 40. Para tu cocina chilena real.
          </p>
        </motion.div>
      </div>
    </section>;
}